
import { Drawer } from "antd";

import { useState } from "react";
import TopFilters from "./TopFilters";
import MazakaDetailsFilterButton from "apps/Common/MazakaDetailsFilterButton";

const MobileTopFilters = () => {
  const [isShowMobileFilterDrawer, setIsShowMobileFilterDrawer] =
    useState(false);
  return (
    <>
    <MazakaDetailsFilterButton
              setIsShowDetailsFilter={ setIsShowMobileFilterDrawer}
            />
     

      <Drawer
        title={"Davatileri  Filtrele"}
        open={isShowMobileFilterDrawer}
        onClose={() => {
          setIsShowMobileFilterDrawer(false);
        }}
      >
        <TopFilters isMobile={true}  />
      </Drawer>
    </>
  );
};

export default MobileTopFilters;
